import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import CopilotContainer from '../../features/Copilot/components/CopilotContainer/CopilotContainer';
import { resetCopilotState } from '../../features/Copilot/data-store/copilotSlice';

import './Copilot.css';

/**
 * Copilot page component
 */
function Copilot() {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    // Collapse host app menu for better space utilization
    const btn = document.querySelector<HTMLButtonElement>(
      '[data-testid="host-side-menu-pin-button"]'
    );
    const alreadyCollapsed = document.body.classList.contains('menu-collapsed');

    if (!alreadyCollapsed) {
      btn?.click();
    }

    // Reset state only when actually leaving copilot (not during internal navigation)
    return () => {
      // Use setTimeout to check the next location after navigation completes
      setTimeout(() => {
        const currentPath = window.location.pathname;
        const isCopilotPath = currentPath.includes('/copilot');

        if (!isCopilotPath) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-call
          dispatch(resetCopilotState());
        }
      }, 0);
    };
  }, [dispatch, location.pathname]);

  return (
    <div className='Copilot-Wrapper'>
      <CopilotContainer />
    </div>
  );
}

export default Copilot;
